import styled from "styled-components";
import { LinkContent } from "./LinkDataInterface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "@mui/material/Tooltip";
import useWindowDimensions from "./windowDimensions";

export function IconsLinks({ icons }: { icons: LinkContent[] }) {
  let templateColumn: string = "";
  let nbColums: number;
  const dimensions = useWindowDimensions();

  if (dimensions.width < dimensions.height) {
    nbColums = Math.min(icons.length / 2, 4);
  } else {
    nbColums = Math.min(icons.length, 8);
  }

  for (let i = 0; i < nbColums; i++) {
    templateColumn = templateColumn + "1fr ";
  }
  return (
    <IconsStyle $template={templateColumn}>
      {icons.map((link) => {
        return <IconLink link={link} />;
      })}
    </IconsStyle>
  );
}

const IconsStyle = styled.div<{ $template: string }>`
  height: 100%;
  width: 100%;

  display: grid;
  grid-template-columns: ${(props) => props.$template};
  column-gap: 5%;
  justify-content: space-between;
  align-items: center;
`;

function IconLink({ link }: { link: LinkContent }) {
  function handleClick() {
    window.open(link.link)?.focus();
  }
  return (
    <Tooltip title={link.title}>
      <IconLinkStyle
        onClick={handleClick}
        $color={link.color}
        $text={link.text}
        $hover={link.hover}
        $textHover={link.textHover}
        $title={link.title}
      >
        <Icon>
          <FontAwesomeIcon icon={link.faLogo} size="2xl" />
        </Icon>
      </IconLinkStyle>
    </Tooltip>
  );
}

const IconLinkStyle = styled.button<{
  $color?: string;
  $text?: string;
  $hover?: string;
  $textHover?: string;
  $title?: string;
}>`
  max-width: 60px;
  max-height: 60px;
  aspect-ratio: 1/1;
  flex: 1;
  border-radius: 20%;
  margin: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${(props) => props.$color};
  border-style: solid;
  border-color: ${(props) => props.$hover};
  color: ${(props) => props.$text};
  &:hover {
    background-color: ${(props) => props.$hover};
    color: ${(props) => props.$textHover};
    border-color: ${(props) => props.$color};
  }
`;

const Icon = styled.div`
  height: auto;
  width: 50px;
`;
